module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-bar-graph-fill-fa3c90f4.svg";